import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { InputTypeTimeDirective } from '@app/shared/directives/input-type-time.directive';
import { PcsFormGroupDirective } from '@app/shared/directives/pcs-form-group.directive';
import { PcsTabPressedDirective } from '@app/shared/directives/pcs-tab-pressed.directive';
import { PreventDefaultEventDirective } from '@app/shared/directives/prevent-default-event.directive';
import { ResizedDirective } from '@app/shared/directives/resized.directive';
import { StickyElementDirective } from '@app/shared/directives/sticky-element.directive';
import { StickyElementWrapperDirective } from '@app/shared/directives/sticky-element-wrapper.directive';
import { PcsStickyPositionDirective } from '@app/shared/directives/sticky-position.directive';
import { StickyWrapperDirective } from '@app/shared/directives/sticky-wrapper.directive';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    PreventDefaultEventDirective,
    PcsTabPressedDirective,
    InputTypeTimeDirective,
    PcsStickyPositionDirective,
    PcsFormGroupDirective,
    StickyWrapperDirective,
    StickyElementWrapperDirective,
    StickyElementDirective,
    ResizedDirective
  ],
  providers: [],
  exports: [
    PreventDefaultEventDirective,
    PcsTabPressedDirective,
    InputTypeTimeDirective,
    PcsStickyPositionDirective,
    PcsFormGroupDirective,
    StickyWrapperDirective,
    StickyElementWrapperDirective,
    StickyElementDirective,
    ResizedDirective
  ]
})
export class DirectivesModule {
}
